import React from 'react';
import './OnboardingVideoModal.css';
import { IoCloseOutline } from 'react-icons/io5';
import { useLanguage } from '../../LanguageProvider';

export default function OnboardingVideoModal({ isOpen, onClose, isFirstLogin = false }) {
  const { getTranslation } = useLanguage();

  if (!isOpen) return null;

  const videoId = 'VYWgmWeTdHY';
  const embedUrl = `https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0&modestbranding=1`;

  const handleContainerClick = (e) => {
    // Close only when clicking on the empty background area
    if (e.target === e.currentTarget && !isFirstLogin) {
      onClose();
    }
  };

  return (
    <div className="onboarding-video-overlay" onClick={handleContainerClick}>
      <div className="onboarding-video-container">
        {!isFirstLogin && (
          <button 
            className="onboarding-video-close" 
            onClick={onClose}
            title={getTranslation("close") || "Close"}
          >
            <IoCloseOutline size={24} />
          </button>
        )}
        <div className="onboarding-video-wrapper">
          <iframe
            src={embedUrl}
            title="Onboarding Video"
            className="onboarding-video-iframe"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
        </div>
        {isFirstLogin && (
          <div className="onboarding-video-footer">
            <button 
              className="onboarding-video-skip" 
              onClick={onClose}
            >
              {getTranslation("skip") || "Skip"}
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

